import { TOGGLE_DRAWER_SUCCESS } from "../../types/admin/themeTypes";
import {
  TOGGLE_USER_TAB_SWITCH_FAIL,
  TOGGLE_USER_TAB_SWITCH_REQUEST,
  TOGGLE_USER_TAB_SWITCH_SUCCESS,
} from "../../types/user/tabSwitchTypes";

export const toggleUserTabSwitchReducer = (
  state = { toggleValue: "" },
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_USER_TAB_SWITCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TOGGLE_USER_TAB_SWITCH_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleValue: payload, // Update the state with the DRAWER value
      };
    case TOGGLE_USER_TAB_SWITCH_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
